import * as React from 'react'
import { SVGProps } from 'react'

const SvgAvatar4 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 83 83"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M41.4 82.8c22.864 0 41.4-18.535 41.4-41.4S64.265 0 41.4 0 0 18.535 0 41.4c0 22.864 18.535 41.4 41.4 41.4Z"
      fill="#EAEAEA"
    />
    <mask
      id="avatar4_svg__a"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={83}
      height={83}
    >
      <path
        d="M41.4 82.8c22.864 0 41.4-18.535 41.4-41.4S64.265 0 41.4 0 0 18.535 0 41.4c0 22.864 18.535 41.4 41.4 41.4Z"
        fill="#EAEAEA"
      />
    </mask>
    <mask
      id="avatar4_svg__b"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={83}
      height={83}
    >
      <path
        d="M41.4 82.8c22.864 0 41.4-18.535 41.4-41.4S64.265 0 41.4 0 0 18.535 0 41.4c0 22.864 18.535 41.4 41.4 41.4Z"
        fill="#EAEAEA"
      />
    </mask>
    <g mask="url(#avatar4_svg__b)">
      <path
        d="M45.292 43.163s11.197-2.54 13.065 7.291c1.867 9.832 19.652 2.48 17.017 17.633-2.635 15.152-20.421 15.041-20.421 15.041L24.983 72.15s-7.91-4.279-4.177-12.628c3.733-8.348 13.654-3.84 12.921-14.937-.733-11.096 11.566-1.422 11.566-1.422Z"
        fill="#120284"
      />
      <path
        d="M28.216 16.602s.267-6.819 11.966-6.597c11.7.222 15.319 9.76 15.978 15.642.659 5.882-.55 18.087-8.015 19.286-7.465 1.2-14.928-9.425-14.928-9.425L28.216 16.6Z"
        fill="#120284"
      />
      <path
        d="M30.74 14.54s-4.638 1.07-6.133 9.848 1.948 18.885 9.12 20.203c7.173 1.318 10.892-1.647 10.892-1.647l-.824-13.95L30.74 14.54Z"
        fill="#120284"
      />
      <path
        d="M86.108 107.502H-5.298V94.987s.176-22.963 25.33-29.172a49.7 49.7 0 0 1 5.596-1.037l15.95-.07h.043l12.834-.056s10.313 1.244 19.332 8.345c6.703 5.276 12.691 13.79 13.194 27.437.1 2.388-.195 4.777-.873 7.068Z"
        fill="#5661E2"
      />
      <path
        d="M38.178 68.636c.232.438.837 22.398.837 22.398l2.611-26.389-3.448 3.99Z"
        fill="#120284"
      />
      <path
        d="M54.454 64.645c-3.192 2.66-6.283 4.279-9.2 5.153h-.019c-9.61 2.882-17.266-2.282-20.247-4.78.216-.082.432-.164.644-.25.56-.224 1.1-.495 1.614-.81 7.595-4.657 6.212-17.45 6.212-17.45h13.486a28.79 28.79 0 0 0 .054 5.414c.447 4.457 2.093 10.395 7.456 12.723Z"
        fill="#C4C4F7"
      />
      <path
        d="M46.988 51.926c-.79 1.352-1.921 2.306-3.523 2.439-6.283.522-9.817-5.65-9.743-6.22l.326-1.633h12.884a28.73 28.73 0 0 0 .056 5.414Z"
        fill="#120284"
      />
      <path
        d="M55.451 34.711c0-1.76-1.243-3.187-2.776-3.187-1.534 0-2.778 1.428-2.778 3.187 0 1.76 1.244 3.973 2.778 3.973 1.533 0 2.776-2.212 2.776-3.973Z"
        fill="#C4C4F7"
      />
      <path
        d="m51.946 35.803-.195-.02c0-.021.238-2.099 2.167-2.15v.197c-1.753.047-1.97 1.954-1.972 1.973Z"
        fill="#120284"
      />
      <path
        d="M53.85 35.508c-.328-.34-.669-.499-.997-.483-.507.03-.85.47-.853.474l-.157-.12c.016-.02.401-.514.996-.549.401-.023.782.16 1.153.535l-.142.143Z"
        fill="#120284"
      />
      <path
        d="M24.607 34.711c0-1.76 1.243-3.187 2.777-3.187 1.533 0 2.778 1.428 2.778 3.187 0 1.76-1.244 3.973-2.778 3.973-1.535 0-2.777-2.212-2.777-3.973Z"
        fill="#C4C4F7"
      />
      <path
        d="m28.42 35.803.195-.02c0-.021-.238-2.099-2.167-2.15v.197c1.754.047 1.97 1.954 1.972 1.973Z"
        fill="#120284"
      />
      <path
        d="M26.515 35.508c.33-.34.669-.499.999-.483.505.03.849.47.853.474l.155-.12c-.016-.02-.401-.514-.995-.549-.4-.023-.782.16-1.152.535l.14.143Z"
        fill="#120284"
      />
      <path
        d="M47.97 46.947c-2.057 2.364-4.661 3.887-7.787 3.836-3.122.05-5.73-1.47-7.788-3.836a.263.263 0 0 0-.036-.042c-3.686-4.66-4.437-11.445-3.438-19.519.718-5.811 6.199-8.065 9.242-8.874a7.844 7.844 0 0 1 4.041 0c3.043.81 8.523 3.063 9.24 8.874 1.003 8.099.245 14.904-3.474 19.561Z"
        fill="#C4C4F7"
      />
      <path
        d="M44.387 35.496a.668.668 0 1 0 0-1.337.668.668 0 0 0 0 1.337ZM35.554 35.496a.668.668 0 1 0 0-1.337.668.668 0 0 0 0 1.337ZM48.67 29.048s-1.746.046-4.037.058c-2.292.011-2.884-.013-2.674-.6.21-.589 2.504-.577 3.937-.374 1.433.203 2.774.916 2.774.916ZM31.117 29.048s1.746.046 4.038.058c2.291.011 2.883-.013 2.673-.6-.21-.589-2.504-.577-3.937-.374-1.433.203-2.774.916-2.774.916ZM39.735 39.519c-.24 0-.477-.038-.61-.16a.36.36 0 0 1-.104-.335c.098-.614.455-3.05.459-3.075l.194.03c0 .023-.361 2.46-.459 3.074a.164.164 0 0 0 .044.16c.183.17.82.105 1.18.025l.042.19a3.792 3.792 0 0 1-.746.09ZM40.406 40.956a3.619 3.619 0 0 1-.711-.064.11.11 0 1 1 .05-.214c.098.023 2.467.535 3.692-1.703a.11.11 0 0 1 .196.026.11.11 0 0 1-.002.08c-.881 1.609-2.352 1.875-3.225 1.875ZM41.916 41.418a.11.11 0 0 1-.022-.218c.165-.032.323-.09.468-.175a.11.11 0 1 1 .111.19 1.7 1.7 0 0 1-.535.2l-.023.003Z"
        fill="#120284"
      />
      <path
        d="M45.058 31.751a4.067 4.067 0 0 0-3.93 3.036 4.06 4.06 0 1 0 7.989 1.026 4.06 4.06 0 0 0-4.06-4.06v-.002Zm0 7.898a3.843 3.843 0 0 1-1.562-.335 3.837 3.837 0 1 1 1.561.336ZM38.366 34.773a4.057 4.057 0 1 0-1.901 4.547c.024-.014.046-.029.07-.04a4.053 4.053 0 0 0 1.829-4.506l.002-.001Zm-2.058 4.385a3.84 3.84 0 1 1 1.971-3.355 3.815 3.815 0 0 1-1.971 3.355Z"
        fill="#fff"
      />
      <path
        d="M41.21 34.816a3.16 3.16 0 0 0-2.916 0l-.116-.185c.058-.035 1.407-.855 3.13 0l-.098.185Z"
        fill="#fff"
      />
      <path
        d="m50.718 23.863.49 13.77 1.034-6.506s2.353-4.905-1.524-7.264ZM29.65 23.863l-.491 13.77-1.035-6.506s-2.353-4.905 1.526-7.264Z"
        fill="#120284"
      />
      <path
        d="M29.207 26.64s2.8-1.428 3.842-5.161c0 0-.443 8.124 7.135 11.254 0 0-6.202-2.086-6.585-11.254 0 0 3.586 5.984 18.235 4.83 0 0 .075-9.225-7.22-9.826-7.294-.602-14.096.385-15.522 3.568-1.427 3.183.115 6.588.115 6.588Z"
        fill="#120284"
      />
      <path
        d="M32.957 21.056s-.668 4.367-4.225 8.05c0 0 3.492-2.273 4.663-8.196l-.438.146ZM33.395 21.056s1.272 6.367 9.31 9.516c0 0-7.955-3.743-8.87-10.013l-.44.497Z"
        fill="#120284"
      />
      <path
        d="M53.552 23.619a.77.77 0 0 0-.857-.135.754.754 0 0 0-.264.21l-.732.926-.008.011-.68.86-.227.283-.498.634.545.64.49-.42.356-.307.154-.134.61-.524 1.079-.925a.753.753 0 0 0 .032-1.119Zm-1.363 1.622-.389.326-.564.47-.084-.101-.021-.027.01-.013.63-.7.212-.237.741-.824.329.39-.864.716Z"
        fill="#F2D7C0"
      />
      <path
        d="M43.23 77.687a.963.963 0 1 0 0-1.925.963.963 0 0 0 0 1.925Z"
        fill="#fff"
      />
      <path
        d="M42.802 76.891a.167.167 0 1 0 0-.334.167.167 0 0 0 0 .334ZM43.666 76.891a.167.167 0 1 0 0-.334.167.167 0 0 0 0 .334Z"
        fill="#C4C4F7"
      />
    </g>
  </svg>
)

export default SvgAvatar4
